import React, {Component} from 'react';
import _ from "lodash";
import formatValue from "../../../../../../../../../../Utils/ListUtils/FormatValue";
import {
    CartesianGrid, ComposedChart,
    Label,
    Legend,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis
} from "recharts";

import ScreenDesignerListHoc from "../../../../../../../../../../HocHelpers/ScreenDesignerListHoc";
import {ChartTitle} from "../../../../../../../../../../Utils/ChartUtils/ChartTitle";
import {
    transformData,
    getColumnType,
    getColumnTypeById, humanizeDuration, isAllDuration,
    isAllInteger, getColumnById, getColumn, renderChartItems
} from "../../../../../../../../../../Utils/ChartUtils/chartUtils";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import FilterListIcon from '@material-ui/icons/FilterList';

class ComposedRechart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            props: {
                axisX: {},
                axisY: {},
                axisTop: {},
                axisRight: {},
                axisBottom: {},
                axisLeft: {}
            }
        }
    }

    componentDidMount() {
        const {
            columns, chartProps = {},
            data: {content} = {},
        } = this.props;
        let newContent = transformData(content, columns);
        this.setState({
            props: chartProps,
            columns: columns,
            listData: newContent || [],
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {
            columns,
            chartProps = {},
            data: {content} = {},
            pivotData = []
        } = this.props;
        const {
            chartProps: prevChartProps = {},
            data: {content: prevContent},
            pivotData: prevPivotData = [],
        } = prevProps;
        let currentData = pivotData.length > 0 ? pivotData : content;
        let prevCurrentData = prevPivotData.length > 0 ? prevPivotData : prevContent;
        if (currentData !== prevCurrentData) {
            let newData = transformData(currentData, columns);
            this.setState({listData: newData})
        }
        if (!_.isEmpty(chartProps) && chartProps !== prevChartProps) {
            this.setState({props: chartProps})
        }
    }

    onLineClick = (obj, name) => {
        console.log(obj, name)
    };

    render() {
        const {
            listData = [],
            columns = [],
            props: {
                indexBy,
                series = [],
                background,
                enableGridX,
                enableGridY,
                enableLabel,
                lineStyle,
                enablePoints,
                axisX: {
                    position: positionX,
                    enable: enableX,
                    interval: intervalX = 0,
                    tickRotation: tickRotationX,
                    tickSize: tickSizeX,
                    label: labelX,
                    labelOffset: labelOffsetX
                } = {},
                axisY: {
                    position: positionY,
                    enable: enableY,
                    interval: intervalY = 0,
                    tickRotation: tickRotationY,
                    tickSize: tickSizeY,
                    label: labelY,
                    labelOffset: labelOffsetY
                } = {},
                legend: {
                    enable: legendEnable,
                    position: legendPosition,
                    verticalAlign,
                    direction,
                    itemHeight,
                    itemWidth,
                    translateY,
                    translateX
                } = {},
            }
        } = this.state;
        const {
            label,
            chartProps: {
                showAdvancedFilter,
                hideTitle,
                title: {
                    styles: {
                        fontSize: {size, type} = {},
                        fontStyle,
                        fontWeight,
                        textDecoration,
                        textAlign,
                        color,
                        background: titleBackground
                    } = {}
                } = {}
            }
        } = this.props;
        return (
            <>
                <div style={{display: 'flex'}}>
                    <div style={{flexGrow: 1}}>
                        <ChartTitle
                            hideLabel={hideTitle}
                            size={size}
                            type={type}
                            fontWeight={fontWeight}
                            fontStyle={fontStyle}
                            textDecoration={textDecoration}
                            textAlign={textAlign}
                            title={label}
                            color={color}
                            background={titleBackground}
                        />
                    </div>
                    {showAdvancedFilter && (
                        <IconButton style={{padding: 2}} disabled>
                            <Icon style={{margin: 5}}>
                                <FilterListIcon/>
                            </Icon>
                        </IconButton>
                    )}
                </div>
                <ResponsiveContainer width={'99%'} height={'99%'}>
                    <ComposedChart
                        data={listData}
                        margin={{
                            top: 20, right: 30, left: 30, bottom: 87,
                        }}
                    >
                        <XAxis
                            hide={!enableX}
                            dataKey={indexBy}
                            orientation={positionX}
                            label={<Label
                                value={labelX}
                                position={positionX}
                                offset={parseInt(labelOffsetX || 0)}
                                angle={0}
                                style={{textAnchor: 'middle'}}
                            />}
                            interval={parseInt(intervalX)}
                            angle={tickRotationX}
                            tickSize={tickSizeX}
                            minTickGap={80}
                            tick={{fontSize: 12}}
                            textAnchor="end"
                            tickFormatter={(v) => {
                                return getColumnTypeById(columns, indexBy) === 'duration' ? humanizeDuration(v, getColumnById(columns, indexBy).format) :
                                    formatValue(v, isAllInteger(columns, indexBy) ? 'integer' : 'number', undefined)
                            }}
                        />
                        <YAxis
                            hide={!enableY}
                            tickFormatter={(v) => {
                                return isAllDuration(columns, indexBy) ? humanizeDuration(v, columns.filter((c) => c.type === 'duration')[0].format) :
                                    formatValue(v, isAllInteger(columns, indexBy) ? 'integer' : 'number', undefined)
                            }}
                            orientation={positionY}
                            label={<Label
                                value={labelY}
                                position={positionY}
                                offset={parseInt(labelOffsetY || 0)}
                                angle={-90}
                                style={{textAnchor: 'middle'}}
                            />}
                            interval={parseInt(intervalY)}
                            angle={tickRotationY}
                            tickSize={tickSizeY}
                            minTickGap={80}
                            tick={{fontSize: 12}}
                            textAnchor={positionY === 'right' ? 'start' : 'end'}
                        />
                        <CartesianGrid
                            strokeDasharray="3 3"
                            horizontal={enableGridX}
                            vertical={enableGridY}
                            fill={background}
                        />
                        <Tooltip
                            isAnimationActive={false}
                            labelFormatter={(value) => {
                                return getColumnTypeById(columns, indexBy) === 'duration' ?
                                    humanizeDuration(value, getColumnById(columns, indexBy).format) :
                                    value
                            }}
                            formatter={(value, name) => {
                                return getColumnType(columns, name) === 'duration' ?
                                    humanizeDuration(value, getColumn(columns, name).format)
                                    : formatValue(value, getColumnType(columns, name), undefined)
                            }}
                        />
                        {legendEnable && (<Legend
                            align={legendPosition}
                            verticalAlign={verticalAlign}
                            layout={direction}
                            height={parseInt(itemHeight)}
                            width={parseInt(itemWidth)}
                            wrapperStyle={{
                                paddingLeft: translateX ? `${translateX}px` : 0,
                                paddingTop: translateY ? `${translateY}px` : 0
                            }}
                        />)}
                        {renderChartItems({
                            columns,
                            series,
                            indexBy,
                            lineStyle,
                            enablePoints,
                            enableLabel,
                            userLanguage: this.props.userLanguage
                        })}
                    </ComposedChart>
                </ResponsiveContainer>
            </>
        );
    }
}

export default ScreenDesignerListHoc(ComposedRechart)
